module.exports = __webpack_public_path__ + "static/media/logo_plus.86b8303c.svg";